import { VIEWER_COLORS } from '../serverDetail/network/netSync'
import type { SpecCursor, SpecViewer } from './useSpecDraft'

// 공동 편집 접속자 표시 도우미 — 색은 네트워크 도면과 같은 8색. 칸 테두리 색은 index.css 의 presence-c0~7

export const viewerColor = (v: SpecViewer) => VIEWER_COLORS[v.color % VIEWER_COLORS.length]

const WHERE: Record<string, string> = { sheet: '디바이스 시트', tags: '태그 편집', panel: '설정', machines: '인터페이스 시트', items: '항목 편집' }
export const whereText = (v: SpecViewer) => (v.cursor ? WHERE[v.cursor.mode] ?? '' : '보는 중')

/** 칸 테두리 표시용 — 키(디바이스/태그) → 칸 → 누가(색·이름표 클래스)·입력 중인지 */
export type CellMark = { color: number; id: string; editing: boolean }
export type CellMarks = Record<string, Record<string, CellMark>>

/** 이름표 클래스용 접속 id (CSS 클래스에 쓸 수 있게) — Presence.tsx 의 PresenceNames 가 이 클래스에 이름을 단다 */
export const viewerClassId = (v: SpecViewer) => v.connectionId.replace(/[^A-Za-z0-9_-]/g, '_')

export function cellMarks(viewers: SpecViewer[], mode: SpecCursor['mode'], rowKey: (v: SpecViewer) => string | null | undefined): CellMarks {
  const out: CellMarks = {}
  for (const v of viewers) {
    if (v.cursor?.mode !== mode || !v.cursor.field) continue
    const key = rowKey(v)
    if (!key) continue
    // 한 칸에 여럿이면 입력 중인 사람이 이긴다
    const prev = out[key]?.[v.cursor.field]
    if (prev?.editing && !v.cursor.editing) continue
    ;(out[key] ??= {})[v.cursor.field] = { color: v.color % VIEWER_COLORS.length, id: viewerClassId(v), editing: !!v.cursor.editing }
  }
  return out
}

export function markClass(marks: CellMarks | undefined, key: string, field: string): string {
  const m = marks?.[key]?.[field]
  return m ? `presence-cell presence-c${m.color} presence-v-${m.id}${m.editing ? ' presence-editing' : ''}` : ''
}
